import { IReactChildrenProps } from '@/interfaces/IReactChildren';

export default function AuthTitle({ children }: IReactChildrenProps) {
	return (
		<h1 className="text-3xl font-bold text-[#0F9015] mb-2 text-center" data-testid="auth-title">
			{children}
		</h1>
	);
}
